import * as types from "../actionTypes";

export const setGeneralAdministrativeExpenseByYear = (key, yearKey, amount) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_GENERAL_ADMINISTRATIVE_EXPENSE_BY_YEAR,
      key,
      yearKey,
      amount,
    });
  };
};

export const setGeneralAdministrativeExpenseByMonth = (
  key,
  yearKey,
  amount
) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_GENERAL_ADMINISTRATIVE_EXPENSE_BY_MONTHS,
      key,
      yearKey,
      amount,
    });
  };
};

export const replaceGeneralAdministrativeExpenseYears = (key, payload) => {
  return (dispatch) => {
    return dispatch({
      type: types.REPLACE_GENERAL_ADMINISTRATIVE_EXPENSE_BY_YEAR,
      key,
      payload,
    });
  };
};

export const resetGeneralAdministrativeExpenseReducer = (key, payload) => {
  return (dispatch) => {
    return dispatch({
      type: types.RESET_GENERAL_ADMINISTRATIVE_EXPENSE_REDUCER,
      key,
      payload,
    });
  };
};
